import { provideAuth0 } from '@auth0/auth0-angular';

export const provideAuthentication = () =>
  provideAuth0({
    domain: AUTH0_DOMAIN,
    clientId: AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: `${window.location.origin}/callback`,
      audience: AUTH0_AUDIENCE,
      scope: AUTH0_SCOPE,
    },
    httpInterceptor: {
      allowedList: [`${API_URL}/*`],
    },
  });
